<div
  #mount
  class="viewer"
  part="viewer-shell">
  <div
    class="toolbar"
    part="viewer-toolbar">
    <div class="document-info">
      <strong
        id="filename"
        part="viewer-title"
        >No document open</strong
      >
      <span
        id="meta"
        part="viewer-meta"></span>
    </div>
    <div
      aria-label="View controls"
      id="viewer-controls"
      part="viewer-controls">
      <div
        aria-label="Word document zoom"
        class="document-zoom"
        hidden
        id="docx-zoom"
        role="group">
        <button
          aria-label="Zoom out"
          id="docx-zoom-out"
          part="viewer-button"
          title="Zoom out"
          type="button">
          −
        </button>
        <button
          aria-label="100%"
          class="zoom-value"
          id="docx-actual"
          part="viewer-button"
          title="Reset zoom to 100%"
          type="button">
          <span
            aria-live="polite"
            id="docx-zoom-label"
            >100%</span
          >
        </button>
        <button
          aria-label="Zoom in"
          id="docx-zoom-in"
          part="viewer-button"
          title="Zoom in"
          type="button">
          +
        </button>
        <span
          aria-hidden="true"
          class="control-divider"></span>
        <button
          aria-label="Fit width"
          id="docx-fit"
          part="viewer-button"
          title="Fit width"
          type="button"></button>
      </div>
      <div id="preview-controls"></div>
      <button
        aria-label="Download original file"
        class="download-button"
        hidden
        id="download"
        part="viewer-download"
        title="Download original file"
        type="button"></button>
    </div>
    <div
      class="tools"
      id="search-tools"
      part="viewer-search">
      <input
        aria-label="Search document text"
        disabled
        id="search"
        part="viewer-search-input"
        placeholder="Search document text"
        type="search" /><button
        disabled
        id="next"
        part="viewer-search-next">
        Next</button
      ><span
        aria-live="polite"
        id="matches"
        part="viewer-search-count"></span>
    </div>
  </div>
  <div
    aria-live="polite"
    id="status"
    part="viewer-status"
    role="status">
    Paste a URL or open a document or image from your computer.
  </div>
  <div
    class="progress-region"
    hidden
    id="progress-region"
    part="viewer-progress">
    <div
      aria-live="polite"
      id="progress-label"></div>
    <progress
      aria-label="Document progress"
      id="progress-bar"
      max="100"
      part="viewer-progress-bar"></progress>
  </div>
  <div class="document-body">
    <main
      aria-label="Document contents"
      id="viewport"
      part="viewer-viewport"
      tabindex="0">
      <div
        id="empty"
        part="viewer-empty">
        @if (emptyStateTemplate(); as template) {
          <ng-container [ngTemplateOutlet]="template" />
        } @else {
          <h1 part="viewer-empty-title">Document viewer</h1>
          <small part="viewer-empty-description">
            XLSX: worksheets and cached formula results.<br />
            DOCX: text, tables, and embedded images.<br />
            PDF: pages, contents, zoom, and text selection.<br />
            Markdown: formatted preview and source.<br />
            JSON: tree, formatted view, and source.<br />
            XML: formatted view and source.<br />
            HTML: source and isolated preview.<br />
            Code: syntax highlighting for common programming and configuration languages.<br />
            Text: TXT, LOG, CSV, TSV, and other text files.<br />
            Images: PNG, APNG, JPEG, GIF, WebP, AVIF, SVG, BMP, and ICO/CUR.<br />
            Additional image formats depend on browser support: TIFF, HEIC/HEIF, JPEG XL, JPEG 2000, RAW, and PSD.
          </small>
        }
      </div>
      <div
        hidden
        id="canvas"></div>
      <div
        hidden
        id="media-preview"></div>
      <div
        hidden
        id="text-preview"></div>
      <iframe
        hidden
        id="docx-frame"
        part="viewer-document-frame"
        referrerpolicy="no-referrer"
        sandbox="allow-same-origin"
        title="Word document preview"></iframe>
    </main>
  </div>
  <footer
    class="viewer-footer"
    part="viewer-footer">
    <nav
      aria-label="Workbook sheets"
      id="tabs"
      part="viewer-sheet-tabs"></nav>
    <span
      id="selection"
      part="viewer-selection"
      >Read-only</span
    ><a
      class="licenses"
      rel="noopener"
      target="_blank"
      [attr.href]="noticesUrl() || null"
      [hidden]="!noticesUrl()"
      >Open-source licenses</a
    >
  </footer>
</div>
